<div class="clearfix">
  <form class="float-start">
    <div i18n="@@Search" style="min-width:200px;">
      <input class="form-control" id="table_search" type="text" name="searchTerm" [(ngModel)]="tableFunctions.searchTerm" i18n-placeholder="@@SearchAll" placeholder="Alles durchsuchen..." />
    </div>
  </form>

  <div class="mb-3 float-end">
    <app-table-filter [defaultFilter]='{"entries":"1000"}' (setFilterEvent)="setFilter($event)"></app-table-filter>
  </div>
</div>
<div *ngIf="tableReady">
  <app-table [table]="table"></app-table>
</div>

<div *ngIf="!tableReady" class="loading-spinner-container">
  <div class="spinner-border text-primary loading-spinner-md" role="status">
    <span class="visually-hidden-focusable" i18n="@@LoadingMessage">Loading...</span>
  </div>
</div>

  <router-outlet></router-outlet>
